import { Box, Modal } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  CustomButton,
  CustomLoader,
  FormModalTitle,
} from "../../../components";
import SigninTextInput from "../../../components/SigninTextInput";
import i18n from "../../../i18n-config";
import {
  Categorie,
  createAsyncCategorie,
  updateAsyncCategorie,
} from "../../../store/features/categorieSlice";
import theme from "../../../theme/theme";
import notifyMessage from "../../../utils/notify";
import { capitalizeFirstLetter } from "../../../utils/strings";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 400, md: 550, lg: 550 },
  backgroundColor: "#ffffff",
  borderRadius: 2,
  padding: 3,
};

interface Props {
  open: boolean;
  item?: Categorie;
  onClose(): void;
}

function CategorieForm({ open, item, onClose }: Props) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<Categorie>({
    libelle: item?.libelle || "",
    referenceFichier: item?.referenceFichier || "",
  });

  const dispatch = useDispatch();

  const onChangeField = (key: string, value: string) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleClose = () => {
    onClose();
  };

  const toggleLoader = () => {
    setLoading(!loading);
  };

  const callback = () => {
    setLoading(false);
    handleClose();
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("create_success")),
      severity: "success",
    });
  };

  const onError = () => {
    setLoading(false);
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("error_occured")),
      severity: "error",
    });
  };

  const onSubmit = () => {
    toggleLoader();
    if (!item) {
      console.log(formData)
      dispatch(createAsyncCategorie(formData, callback, onError) as any);
    } else {
      dispatch(
        updateAsyncCategorie({ ...item, ...formData }, callback, onError) as any
      );
    }
  };

  const disabled = !formData.libelle.trim();

  return (
    <Modal open={open} onClose={handleClose}>
      <form>
        <Box sx={style}>
          <FormModalTitle
            title={i18n.t(!item ? "creer_categorie" : "update_categorie")}
            onClose={handleClose}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("libelle"))}
            value={formData.libelle}
            onChange={(value: string) => onChangeField("libelle", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("reference_fichier"))}
            value={formData.referenceFichier}
            onChange={(value: string) => onChangeField("referenceFichier", value)}
          />

          <CustomButton
            title={capitalizeFirstLetter(
              i18n.t(!item ? "ajouter" : "modifier")
            )}
            onClick={onSubmit}
            disabled={disabled}
            rootStyle={{
              width: "100%",
              height: 50,
              marginTop: 3,
              marginBottom: 2,
              backgroundColor: disabled
                ? theme.colors.disabled
                : theme.colors.primary,
            }}
            titleStyle={{ color: theme.colors.white }}
          />
        </Box>
        <CustomLoader open={loading} handleClose={toggleLoader} />
      </form>
    </Modal>
  );
}

export default CategorieForm;
